import type { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';
import { getFBCreativesOptions } from '../api';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import useFacebookAdsLibraryParams from '../hooks/useFacebookAdsLibraryParams';

const PAGE_SIZE = 50;

const DataLoadTimestamp: FC = () => {
  const {
    adTypes,
    languages,
    ordering,
    branches,
    pageName,
    startDate,
    endDate,
    company,
    domains,
    flows,
    isRunning,
    newOnly,
    includeWelltech,
    network,
    region,
  } = useFacebookAdsLibraryParams();

  const {
    data: { loadTs },
  } = useSuspenseInfiniteQuery(
    getFBCreativesOptions({
      date_from: format(startDate, 'yyyy-MM-dd'),
      date_to: format(endDate, 'yyyy-MM-dd'),
      desc: ordering.split(':')[1] === 'desc',
      limit: PAGE_SIZE,
      order_by: ordering.split(':')[0],
      offset: 0,
      branch_id: branches,
      page_id: pageName,
      company_id: company,
      domain: domains,
      flow: flows,
      language: languages,
      ad_creative_type: adTypes,
      running: isRunning,
      new_only: newOnly,
      include_welltech: includeWelltech,
      network,
      region,
    })
  );

  if (!loadTs) return null;

  const date = new Date(loadTs);
  const formatted = formatInTimeZone(date, 'UTC', "MMM d, yyyy HH:mm '(UTC+0)'");

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
      <Typography variant="caption" color="text.secondary" noWrap>
        Last data synchronization happened on: {formatted}
      </Typography>
    </Box>
  );
};

export default DataLoadTimestamp;
